export default {"src":"/_next/static/media/gg_dollar.e80cf484.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};